import type { Dimension, Point } from 'types/common_types';
import type { CartPhoto } from 'types/photo_types';

export type WallPreview = {
  id: number;
  customer_id: string;
  name: string;
  created_at: string;
  updated_at: string;
  url?: string;
};

export type SaveWallPreviewPOSTData = {
  name: string;
  wall_preview: {
    is_user_background: boolean;
    background_image: string;
    background_dimensions: Dimension;
    products: WallPreviewCanvas[];
  };
};

export type WallPreviewCanvas = {
  crop_data: {
    canvasDegreesRotated: number;
    borderColor?: string;
    photos: CartPhoto[];
  };
  option_ids: (string | number)[];
  custom_size: Dimension | null;
  product_id: number;
  template_id: number;
  product_dimensions: Dimension;
  position: Point;
};
